import { Injectable } from '@angular/core';
import { RequestData } from 'src/app/common/models/request-data.model';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DayEndReportService {




  constructor(private http: HttpClient) { }
  // getWeekDefNoList(): Observable<any> {
  //   return this.http.get(environment.baseUrl+'/hq/week-def/get');

  // }

  getTerminalList(requestData: RequestData): Observable<any> {
    return this.http.post(environment.baseUrl + '/shop/terminal/get', requestData);

  }
  getUsers(): Observable<any> {
    let search = { "search": { "filters": { "column": [], "scope": { "limit": 1000, "offset": 0 } }, "sort": [] } };
    return this.http.post(environment.baseUrl + '/user/get', search);
  }
  exportDailySalesReport(data: any): Observable<any> {
    return this.http.post(
      environment.baseUrl + '/shop/reports/day-end-report',
      data,
      { responseType: 'blob' }
    );
  }
}
